import React from "react";
import { getFallbackItemPicture, getFilteredLineItemName, getFilteredLineItemVariant, getItemPicture } from "../Helpers/OderUtils";

const LineItem = ({ item, order, egiftcard }) => {
    const variantName = getFilteredLineItemVariant(item);
    const productName = getFilteredLineItemName(item, order);
    const totalPrice = item.line_total_formatted || item.price_formatted || item.price;

    return (
        <div className="line-item-container">
            <div className="line-items-column-1">
                <img className="order-item-image" src={getItemPicture(item.sku)} alt={item.title} onError={e => (e.target.src = getFallbackItemPicture())} />
                <div className="layout vertical">
                    <span className="line-item-title">{productName}</span>
                    {!egiftcard && variantName && <span className="line-item-variant-name">{variantName}</span>}
                    <span className="line-item-price-mobile">{totalPrice}</span>
                </div>
            </div>
            <div className="line-items-column-2">
                <span className="line-item-quantity">{item.quantity}</span>
            </div>
            <div className="line-items-column-3">
                <span className="line-item-price">{totalPrice}</span>
            </div>
        </div>
    );
};

export default LineItem;
